import { FieldConfig } from '@core/components/crudbuilder/models/field-config';

export class DropdownItem {
  constructor(
    public key: any,
    public value: any = null
  ) {
    if (!this.value) {
      this.value = this.key;
    }
  }
}

export interface DropdownData {
  contents: Array<DropdownItem>;
}

export class DropdownFieldConfig extends FieldConfig {
  constructor(
    public name,
    public label              = null,
    public data: DropdownData = null,
    public logoIcon = '',
  ) {
    super(name, FieldConfig.TYPE_DROPDOWN, label, data, logoIcon);
  }
}
